/**
 * GA4 + Clarity E-commerce Event Tracking
 * Also includes Judge.me badge display fix
 */

(function() {
  'use strict';

  // ========================================
  // Judge.me Badge Display Fix
  // Dynamically inject CSS to override hidden badges
  // ========================================
  (function fixJudgeMeBadges() {
    var css = [
      '.jdgm-preview-badge[data-template="product"]{display:block!important;visibility:visible!important}',
      '.jdgm-preview-badge[data-template="collection"]{display:block!important;visibility:visible!important}',
      '.jdgm-preview-badge[data-template="index"]{display:block!important;visibility:visible!important}',
      '.jdgm-review-widget[data-from-snippet="true"]{display:block!important;visibility:visible!important}',
      '.jdgm-verified-count-badget[data-from-snippet="true"]{display:block!important;visibility:visible!important}',
      '.jdgm-carousel-wrapper[data-from-snippet="true"]{display:block!important;visibility:visible!important}',
      '.jdgm-all-reviews-text[data-from-snippet="true"]{display:block!important;visibility:visible!important}',
      '.jdgm-ugc-media-wrapper[data-from-snippet="true"]{display:block!important;visibility:visible!important}',
      '.jdgm-prev-badge__text{visibility:visible!important}',
      '.jdgm-rev-widg__title{visibility:visible!important}',
      '.jdgm-rev-widg__summary-text{visibility:visible!important}',
      '.jdgm-prev-badge[data-average-rating="0.00"]{display:block!important;visibility:visible!important}',
      '.jdgm-prev-badge{margin-top:4px;margin-bottom:4px}',
      '.jdgm-prev-badge .jdgm-star{font-size:14px}',
      '.jdgm-prev-badge__text{font-size:13px;color:#555;margin-left:4px}'
    ].join('');

    var style = document.createElement('style');
    style.id = 'jdgm-badge-fix';
    style.textContent = css;
    document.head.appendChild(style);
  })();

  // ========================================
  // GA4 E-commerce Event Tracking
  // ========================================
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }

  function getPageType() {
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.page) {
      return window.ShopifyAnalytics.meta.page.pageType || '';
    }
    var path = window.location.pathname;
    if (path.match(/^\/products\/[^/]+\/?$/)) return 'product';
    if (path.match(/^\/collections\/[^/]+\/?$/)) return 'collection';
    if (path.match(/^\/cart\/?$/)) return 'cart';
    if (path.match(/^\/checkout\/?/)) return 'checkout';
    if (path === '/' || path === '') return 'home';
    return 'other';
  }

  function getProductData() {
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      var p = window.ShopifyAnalytics.meta.product;
      return {
        item_id: p.id ? p.id.toString() : undefined,
        item_name: p.title,
        price: p.price ? (p.price / 100).toFixed(2) : undefined
      };
    }
    var ld = document.querySelector('script[type="application/ld+json"]');
    if (ld) {
      try {
        var data = JSON.parse(ld.textContent);
        if (data['@type'] === 'Product') {
          return {
            item_id: data.productID || data.sku,
            item_name: data.name,
            price: data.offers && data.offers.price ? data.offers.price : undefined
          };
        }
      } catch (e) {}
    }
    return null;
  }

  function trackViewItem() {
    var product = getProductData();
    if (!product) return;
    gtag('event', 'view_item', {
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
      value: parseFloat(product.price) || 0,
      items: [{
        item_id: product.item_id || 'unknown',
        item_name: product.item_name || 'Unknown Product',
        price: parseFloat(product.price) || 0,
        quantity: 1
      }]
    });
  }

  function trackAddToCart() {
    var product = getProductData();
    var originalFetch = window.fetch;
    window.fetch = function() {
      var url = arguments[0];
      var options = arguments[1] || {};
      var urlStr = typeof url === 'string' ? url : (url && url.url ? url.url : '');
      if (urlStr.indexOf('/cart/add') !== -1 || urlStr.indexOf('/cart/add.js') !== -1) {
        try {
          var body = options.body;
          var data = {};
          if (body) {
            if (typeof body === 'string') data = JSON.parse(body);
            else if (typeof body === 'object') data = body;
          }
          var qty = data.quantity || 1;
          var itemName = product ? product.item_name : 'Unknown Product';
          var itemId = data.id || (product ? product.item_id : 'unknown');
          var price = product ? parseFloat(product.price) : 0;
          gtag('event', 'add_to_cart', {
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
            value: price * qty,
            items: [{ item_id: itemId, item_name: itemName, price: price, quantity: qty }]
          });
          if (window.clarity) window.clarity('event', 'add_to_cart');
        } catch (e) {}
      }
      return originalFetch.apply(this, arguments);
    };

    var originalOpen = XMLHttpRequest.prototype.open;
    var originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(method, url) {
      this._url = url;
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function(body) {
      var url = this._url || '';
      if (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/add.js') !== -1) {
        try {
          var data = {};
          if (body && typeof body === 'string') data = JSON.parse(body);
          var qty = data.quantity || 1;
          var itemName = product ? product.item_name : 'Unknown Product';
          var itemId = data.id || (product ? product.item_id : 'unknown');
          var price = product ? parseFloat(product.price) : 0;
          gtag('event', 'add_to_cart', {
            currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD',
            value: price * qty,
            items: [{ item_id: itemId, item_name: itemName, price: price, quantity: qty }]
          });
          if (window.clarity) window.clarity('event', 'add_to_cart');
        } catch (e) {}
      }
      return originalSend.apply(this, arguments);
    };
  }

  function trackBeginCheckout() {
    document.addEventListener('click', function(e) {
      var target = e.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"], [href*="/checkout"]');
      if (target) {
        gtag('event', 'begin_checkout', {
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
        });
        if (window.clarity) window.clarity('event', 'begin_checkout');
      }
    });
  }

  function init() {
    var pageType = getPageType();
    if (pageType === 'product') {
      trackViewItem();
      trackAddToCart();
    }
    if (pageType === 'cart') {
      trackBeginCheckout();
    }
    if (window.Shopify && window.Shopify.checkout) {
      var checkout = window.Shopify.checkout;
      var items = [];
      if (checkout.line_items) {
        checkout.line_items.forEach(function(line) {
          items.push({
            item_id: line.product_id ? line.product_id.toString() : (line.variant_id ? line.variant_id.toString() : 'unknown'),
            item_name: line.title || 'Unknown',
            price: parseFloat(line.price) || 0,
            quantity: line.quantity || 1
          });
        });
      }
      gtag('event', 'purchase', {
        transaction_id: checkout.order_id ? checkout.order_id.toString() : (checkout.token || 'unknown'),
        value: parseFloat(checkout.total_price) || 0,
        currency: checkout.currency || 'USD',
        tax: parseFloat(checkout.total_tax) || 0,
        shipping: parseFloat(checkout.shipping_rate ? checkout.shipping_rate.price : 0) || 0,
        items: items
      });
      if (window.clarity) window.clarity('event', 'purchase');
    }
    if (window.clarity) window.clarity('set', 'page_type', pageType);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

// ========================================
// FZ GA4 bridge v2 (2026-10-14)
// 1) Forwards plain-object custom events from product body_html
//    (pdp_view / pdp_section_view / reviews_widget_loaded) into gtag
//    command form, since gtag.js only processes array-form commands.
// 2) Owns section-view tracking itself: observes [data-ga-section]
//    blocks and emits pdp_section_view directly (does not rely on
//    inline body scripts).
// 3) Polls for the Judge.me review widget and emits
//    reviews_widget_loaded once.
// view_item / add_to_cart / begin_checkout / purchase remain owned
// by the standard funnel code above.
// ========================================
(function () {
  'use strict';
  window.dataLayer = window.dataLayer || [];
  var origPush = window.dataLayer.push.bind(window.dataLayer);
  var sent = {};

  function emit(name, params) {
    if (sent[name + ':' + (params && params.section || '')]) return;
    sent[name + ':' + (params && params.section || '')] = 1;
    origPush(['event', name, params || {}]);
    try { if (window.clarity) window.clarity('event', name); } catch (e) {}
  }

  function forward(entry) {
    if (!entry || typeof entry !== 'object' || entry instanceof Array) return;
    if (!entry.event) return;
    if (entry.event === 'pdp_section_view') { emit('pdp_section_view', { section: entry.section }); return; }
    if (entry.event === 'reviews_widget_loaded') { emit('reviews_widget_loaded', {}); return; }
    if (entry.event === 'pdp_view') return; // standard view_item covers this
    var params = {};
    for (var k in entry) {
      if (k === 'event') continue;
      if (k === 'ecommerce' && entry[k] && entry[k].items) { params.items = entry[k].items; continue; }
      params[k] = entry[k];
    }
    origPush(['event', entry.event, params]);
  }

  for (var i = 0; i < window.dataLayer.length; i++) forward(window.dataLayer[i]);
  window.dataLayer.push = function () {
    for (var j = 0; j < arguments.length; j++) forward(arguments[j]);
    return origPush.apply(null, arguments);
  };

  // --- own section observer (theme level, works for every product) ---
  function sectionName(el) {
    var m = (el.className || '').match(/fzsec-([a-z0-9-]+)/);
    return m ? m[1] : '';
  }
  function observeSections() {
    var els = document.querySelectorAll('.fzsec');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          emit('pdp_section_view', { section: sectionName(en.target) });
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.25 });
    els.forEach(function (el) { io.observe(el); });
  }

  // --- judge.me widget load signal ---
  function watchReviews() {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      var w = document.querySelector('#judgeme_product_reviews .jdgm-rev, #judgeme_product_reviews .jdgm-prev-badge');
      if (w) { clearInterval(t); emit('reviews_widget_loaded', {}); }
      else if (tries > 60) clearInterval(t);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observeSections(); watchReviews(); });
  } else { observeSections(); watchReviews(); }
})();
